import baseImageSrc from './assets/gray_error.png';
import mildangImageSrc from './assets/gray_error_mildang.png';
import PosterTemplate, { PosterTemplateProps } from 'components/molecules/PosterTemplate';

// 레거시 DS는 @shared를 가져오지 않아 isProject('mildang')와 같은 기준(값이 없으면 mildang)을 직접 쓴다.
const isMildang = (process.env.NEXT_PUBLIC_PROJECT_TARGET ?? 'mildang').split('.')[0] === 'mildang';
const defaultImageSrc = isMildang ? mildangImageSrc : baseImageSrc;

export interface ErrorTemplateProps {
  imageSrc?: PosterTemplateProps['imageSrc'];
  alt?: PosterTemplateProps['alt'];
  title: PosterTemplateProps['title'];
  description?: PosterTemplateProps['description'];
  action: PosterTemplateProps['action'];
  className?: PosterTemplateProps['className'];
}

function ErrorTemplate(props: ErrorTemplateProps) {
  const { imageSrc = defaultImageSrc, alt = 'error image', title, description, action, className } = props;

  return (
    <PosterTemplate
      imageSrc={imageSrc}
      imageWidth={280}
      imageHeight={280}
      alt={alt}
      title={title}
      description={description}
      action={action}
      className={className}
    />
  );
}

export default ErrorTemplate;
